import 'date-convert-npm'

var DC = window.dateConvert

export const dateConvert = new DC()
const everyDayMS = 86400000 // 60 * 60 * 24 * 1000

export const dateFun = {
  // 得到当前年份
  getYear: date => {
    return date.getFullYear()
  },
  // 得到当前月份
  getMonth: date => {
    return date.getMonth() + 1
  },
  getDay: date => {
    return date.getDate()
  },
  // 判断闰年
  isLeapYear: year => {
    if (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) {
      return true
    } else {
      return false
    }
  },

  // 获取本月总日数方法
  getCurmonDaynum: date => {
    var year = date.getFullYear()
    var month = date.getMonth()
    if (this.isLeapYear(year)) {
      // 闰年
      switch (month) {
        case 0:
          return '31'
        case 1:
          return '29'
        case 2:
          return '31'
        case 3:
          return '30'
        case 4:
          return '31'
        case 5:
          return '30'
        case 6:
          return '31'
        case 7:
          return '31'
        case 8:
          return '30'
        case 9:
          return '31'
        case 10:
          return '30'
        case 11:
          return '31'
        default:
      }
    } else {
      // 平年
      switch (month) {
        case 0:
          return '31'
        case 1:
          return '28'
        case 2:
          return '31'
        case 3:
          return '30'
        case 4:
          return '31'
        case 5:
          return '30'
        case 6:
          return '31'
        case 7:
          return '31'
        case 8:
          return '30'
        case 9:
          return '31'
        case 10:
          return '30'
        case 11:
          return '31'
        default:
      }
    }
  },

  // 前几天
  setPrevDate: (date, i) => {
    let dateZero = new Date(dateConvert.convert(date, 'yyyy-MM-dd')).getTime()

    return new Date(dateZero - everyDayMS * i)
  },

  // 后几天
  setNextDate: (date, i) => {
    let dateZero = new Date(dateConvert.convert(date, 'yyyy-MM-dd')).getTime()

    return new Date(dateZero + everyDayMS * i)
  }
}
